import {
  formatError,
  login,
  runLogoutTimer,
  saveTokenInLocalStorage,
  clearTokenFromLocalStorage,
  signUp,
} from "../../services/AuthService";

export const SIGNUP_CONFIRMED_ACTION = "[signup action] confirmed signup";
export const SIGNUP_FAILED_ACTION = "[signup action] failed signup";
export const LOGIN_CONFIRMED_ACTION = "[login action] confirmed login";
export const LOGIN_FAILED_ACTION = "[login action] failed login";
export const LOADING_TOGGLE_ACTION = "[Loading action] toggle loading";
export const LOGOUT_ACTION = "[Logout action] logout action";
export const NAVTOGGLE = "NAVTOGGLE";

// ─── Login ───────────────────────────────────────────────────────────────────

export function loginAction(phone, password, navigate) {
  return (dispatch) => {
    dispatch(loadingToggleAction(true));
    login(phone, password)
      .then((response) => {
        const token = response.data?.token || "";
        const user = {
          role: response.data?.role,
          ...(response.data?.data || {}),
        };
        const payload = saveTokenInLocalStorage(token, user);
        runLogoutTimer(
          dispatch,
          new Date(payload.expireDate).getTime() - Date.now(),
          navigate,
        );
        dispatch(loginConfirmedAction(payload));
      })
      .catch((error) => {
        console.log(error, "error");

        const errorMessage = formatError(error?.response?.data || {});
        dispatch(loginFailedAction(errorMessage));
      })
      .finally(() => dispatch(loadingToggleAction(false)));
  };
}

// ─── Signup ──────────────────────────────────────────────────────────────────

export function signupAction(name, phone, password, navigate) {
  return (dispatch) => {
    dispatch(loadingToggleAction(true));
    signUp(name || phone.split("@")[0] || "Admin", phone, password)
      .then((response) => {
        const token = response.data?.token || "";
        const user = response.data?.data || {};
        const payload = saveTokenInLocalStorage(token, user);
        runLogoutTimer(
          dispatch,
          new Date(payload.expireDate).getTime() - Date.now(),
          navigate,
        );
        dispatch(confirmedSignupAction(payload));
        navigate("/dashboard");
      })
      .catch((error) => {
        const errorMessage = formatError(error?.response?.data || {});
        dispatch(signupFailedAction(errorMessage));
      })
      .finally(() => dispatch(loadingToggleAction(false)));
  };
}

// ─── Logout ──────────────────────────────────────────────────────────────────

export function Logout(navigate) {
  return (dispatch) => {
    clearTokenFromLocalStorage();
    dispatch({ type: LOGOUT_ACTION });
    navigate("/login");
  };
}

// ─── Simple action creators ──────────────────────────────────────────────────

export function loginConfirmedAction(data) {
  return { type: LOGIN_CONFIRMED_ACTION, payload: data };
}

export function loginFailedAction(data) {
  return { type: LOGIN_FAILED_ACTION, payload: data };
}

export function confirmedSignupAction(payload) {
  return { type: SIGNUP_CONFIRMED_ACTION, payload };
}

export function signupFailedAction(message) {
  return { type: SIGNUP_FAILED_ACTION, payload: message };
}

export function loadingToggleAction(status) {
  return { type: LOADING_TOGGLE_ACTION, payload: status };
}

export const navtoggle = () => ({ type: NAVTOGGLE });
